<template>
  <div class="wrapper">
    <FORM  ref="childForm"  @formclick="formclick" :formData="formData"></FORM>
    <table-page ref="childTable"  @btnclick="bthClick" :pageData="pageData"></table-page>
  </div>
</template>

<script>
  //table封装组件
  import tablePage from '@/components/page/table.vue'
  import FORM from '@/components/page/form.vue'
  import URL from '@/views/crs36/util/url'
  import DateUtil from '@/utils/IM/tradeDataUtil.js'

  let language={"zh_CN":"中文","en_US":"英文","vi_VN":"越南文","hi_IN":"印度文"};//语言
 // 存款:(不需要),行情列表(不需要),产品页面(uicode),详情页面(完整资讯URL),链接页面(完整URL)
  let contentType = {0:"编辑内容",1:"存款",2:"行情列表",3:"产品页面",4:"详情页面",5:"链接页面"};
  let autoType = {1:"新安装app-未注册（60分钟）",2:"新安装app-未注册（1天+60分钟）",3:"新安装app-未注册（2天+60分钟）",4:"开户后60分钟-开户积分奖励未领取",5:"开户后24小时--开户积分奖励未领取",6:"开户后3天--开户积分奖励未领取"
    ,7:"开户3天未激活",8:"签到任务未完成",9:"签到任务没领奖",10:"日常交易任务已完成未领取",11:"已激活-未上传身份证",12:"已激活-未上银行卡",13:"已激活-已上传身份证-积分未领取",14:"已激活-已上传银行卡-积分未领取",15:"自己导入的用户分群"}
  export default {
    name: 'list',
    components: {
      tablePage,
      FORM,
    },
    methods: {
      bthClick(clickName, row) {

      },
      /*查询表单按钮点击事件*/
      formclick(clickName, data) {
        if ("查询" == clickName) {
          this.queryData = data;
          this.$refs.childTable.defaultGetData(data);
        }
      },
    },
    data () {
      return {
        deleteIds:"",
        queryData:{},
        /*from查询表单*/
        formData:{
          hasLable: true,
          cols:[
              { title:'用户', field: 'customer'},
              {click:"查询"},
          ]
        },
        /*table生成*/
        pageData: {
          queryUrl: URL.autoMsg.user.qurey, //请求路径和参数
          sequence: true,
          cols: [
              { title: 'id', field: 'id'},
              { title: '触发类型', field: 'autoType',render:(data,full)=>{
                return autoType[data];
                }},
              { title: '语言', field: 'language',render:(data,full)=>{
                  return language[data];
                }},
              { title: '用户', field: 'customer'},
              { title: '推送时间', field: 'createTime',render:(data,full)=>{
                  return DateUtil.formatDate(data,"yyyy-MM-dd hh:mm:ss");
                }},
          ]
        }
      }
    }
  }
</script>
